import type { ReactNode } from 'react';

export type ProcessingState =
  | 'queued'
  | 'running'
  | 'needs_action'
  | 'succeeded'
  | 'failed';

export interface ProcessingAction {
  label: ReactNode;
  ariaLabel: string;
  href?: string;
  onInvoke?: () => void;
  loading?: boolean;
}

export interface ProcessingItem {
  key: string;
  resourceType: 'document' | 'listing' | 'asset';
  resourceId: string;
  title: ReactNode;
  notificationTitle: string;
  detail: ReactNode;
  state: ProcessingState;
  startedAt?: string | null;
  primaryAction?: ProcessingAction;
}

export const workingStates = new Set<ProcessingState>(['queued', 'running']);
export const terminalStates = new Set<ProcessingState>([
  'needs_action',
  'succeeded',
  'failed',
]);
